<template>
  <div class="row">
    <!--  在线实战项目列表  -->
    <div class="flex xs12">
      <va-card title="在线实战项目列表">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button
                disabled
                flat
                color="gray"
              >课程标签：</va-button>
              <va-button
                flat
                :color="tagId !==null ? 'gray' : 'info'"
                v-on:click="handleTagIdChange(null)"
              >全部标签</va-button>
              <va-button
                flat
                :color="tagId === val.id ? 'info' : 'gray'"
                :key="val.id" v-for="val in courseTags"
                v-on:click="handleTagIdChange(val.id)"
              >{{ val.name }}</va-button>
            </va-button-group>
            <va-button-group>
              <va-button
                disabled
                flat
                color="gray"
              >发布状态：</va-button>
              <va-button
                v-for="status in statusOptions"
                :key="status.CODE"
                flat
                :color="computedColor(status.CODE)"
                @click="handleStatusChange(status.CODE)"
              >{{status.TEXT}}</va-button>
            </va-button-group>
          </div>
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="name"
              placeholder="搜索课程名称"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small outline @click="$router.push('saveOnlineAction')">创建在线实战项目</va-button>
            </div>
          </div>

        </div>
        <va-data-table
          :fields="fields"
          :data="onlineActions"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listOnlineAction"
          api-mode
        >
          <template slot="imgUrl" slot-scope="props">
            <img :src="props.rowData.imgUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>

          <template slot="status" slot-scope="props">
            <va-badge :color=computeStatus(props.rowData.status).color>
              {{ computeStatus(props.rowData.status).text }}
            </va-badge>
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              v-bind:style="{margin: '1rem auto', width: '50%'}"
              oninput="if(value<0)value=1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateOnlineAction/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
            <va-popover message="查看报名统计" placement="top">
              <va-button flat small color="gray" icon="vuestic-iconset vuestic-iconset-statistics va-icon vuestic-iconset vuestic-iconset-statistics"
                :to='{path: `/admin/applications/listAppliedCourse`, query:{serviceType: appliedServiceType.ONLINE_ACTION.CODE, serviceId: props.rowData.id }}'/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除在线实战项目"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import onlineActionApi from '../../../api/onlineAction'
import {
  APPLIED_SERVICE_TYPE,
  SERVICE_AUDIT_TYPES,
  SERVICE_STATUS_TYPES,
  TAG_TYPE,
} from '../../../utils/constants'
import { computeServiceStatus, formatTime } from '../../../utils/common'
import tagApi from '../../../api/tag'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      onlineActions: [],
      name: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      status: 1,
      auditStatus: SERVICE_AUDIT_TYPES.APPROVED.CODE,
      statusOptions: SERVICE_STATUS_TYPES,
      courseTags: [],
      tagId: null,
      appliedServiceType: APPLIED_SERVICE_TYPE,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:imgUrl',
          title: '封面图',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: '课程名称',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'views',
          title: '学习人数',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '18%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listCourseTag()
    this.listOnlineAction()
  },
  methods: {
    listOnlineAction (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        status: this.status,
        auditStatus: this.auditStatus,
        tagId: this.tagId,
        name: this.name,
      }
      onlineActionApi.listOnlineAction(params).then(response => {
        this.onlineActions = response.onlineActions
        this.onlineActions.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    handleStatusChange (status) {
      this.status = status
      this.listOnlineAction()
    },
    handleTagIdChange (tagId) {
      this.tagId = tagId
      this.listOnlineAction()
    },
    confirmDelete () {
      if (this.deleteId === null) return
      onlineActionApi.deleteOnlineAction(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除在线实战项目成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listOnlineAction()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    search: debounce(function (name) {
      this.name = name
      this.listOnlineAction()
    }, 400),
    updateSortNum: function (params) {
      const data = {
        id: params.id,
        sortNum: params.sortNum,
      }
      onlineActionApi.updateOnlineAction(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listOnlineAction()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computedColor: function (status) {
      return this.status === status ? 'info' : 'gray'
    },
    computeStatus: function (status) {
      return computeServiceStatus(status)
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 2%;
}
</style>
